import { Component, Input, computed } from '@angular/core';

type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
type BadgeSize = 'sm' | 'md';

/**
 * Small pill label used to convey status, category, or count in a compact visual format.
 */
@Component({
  selector: 'es-badge',
  template: `
    <span [class]="classes()">
      @if (icon) {
        <span class="text-[10px]">{{ icon }}</span>
      }
      {{ label }}
    </span>
  `,
})
export class BadgeComponent {
  @Input({ required: true }) label!: string;
  @Input() variant: BadgeVariant = 'secondary';
  @Input() size: BadgeSize = 'sm';
  @Input() icon?: string;

  classes = computed(() => {
    const base = 'inline-flex items-center gap-1 rounded-full font-medium';
    const variants: Record<BadgeVariant, string> = {
      primary: 'bg-echo-blue/15 text-echo-blue',
      secondary: 'bg-[var(--bg-secondary)] text-[var(--text-secondary)]',
      success: 'bg-green-500/15 text-green-400',
      warning: 'bg-star-orange/15 text-star-orange',
      danger: 'bg-red-500/15 text-red-400',
    };
    const sizes: Record<BadgeSize, string> = {
      sm: 'px-2 py-0.5 text-[10px]',
      md: 'px-2.5 py-1 text-xs',
    };
    return `${base} ${variants[this.variant]} ${sizes[this.size]}`;
  });
}
